import moment from "moment";
import Image from "next/image";
// import React, { useState, useEffect, useRef } from "react";
import React, { useState, useRef, useCallback } from "react";

import { date } from "yup";
import { deleteIcon } from "../../../../assets/icons";
import Button from "../../../elements/button";
import CalendarModal from "../../../elements/calendar";
import Card from "../../../elements/card";
import Input, { EditInput } from "../../../elements/input";
import RadioInput from "../../../elements/radio";
import DropDown from "../../../elements/select";
import * as Yup from "yup";
import { ErrorMessage, useFormik } from "formik";
import { Modal } from "@headlessui/react";
// import React, { useState } from "react";
// import countriesData from "./Country.json"; // Import the JSON data
// import { Card, Button, Image } from "./your-components-path"; // Import necessary
import countriesData from "../../../sections/profile/Country.json";
import axios from "axios";
import { authClient } from "../../../../api-client";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import * as cookie from "cookie";
import * as setCookie from "set-cookie-parser";
import Cookie from "universal-cookie";
import { toast } from "react-toastify";
import { debounce } from "lodash"; // Import lodash debounce

const cookies = new Cookie();

const config = {
  headers: {
    "Content-Type": "application/json",
    authorization: `Bearer ${cookies.get("authToken")}`,
  },
};
// import { EditInput } from '../input';
// import { EditInput } from '../../../elements/input';
const AddBankModal = ({
  setAddBankModal,
  selectedInput,
  setSelectedInput,
  options,
  loading,
  updateBank,
  accountNumber,
  setAccountNumber,
  accountNo,
  setAccountNo,
  value,
  setValue,
}) => {
  const { handleChange, handleSubmit, errors, values, touched, setFieldValue } =
    useFormik({
      initialValues: { accountNumber: "" },
      validationSchema: Yup.object({
        accountNumber: Yup.string().required("Account number is required"),
      }),
      onSubmit: (values) => {
        setAccountNo(values.accountNumber?.replace(/[^a-zA-Z0-9 ]/g, ""));
      },
    });

  return (
    <section className="h-full w-screen z-50 bg-black flex items-center justify-center fixed top-0 left-0 bg-opacity-40">
      <Card className="w-96">
        <div className="flex items-center justify-between">
          <div></div>
          <div>
            <button onClick={() => setAddBankModal(false)}>
              <Image src={deleteIcon} alt="Stakecut | Affiliate Marketplace" />
            </button>
          </div>
        </div>
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            handleSubmit();
            updateBank();
          }}
        >
          <div className="mb-7 mt-10">
            <h2 className="text-md font-medium">Select Bank</h2>
          </div>
          <Input
            placeholder="Enter Account Number"
            onChange={(e) => {
              setFieldValue("accountNumber", e.target.value);
              setAccountNo(e.target.value);
            }}
            type="text"
            name="accountNumber"
            value={values.accountNumber}
            error={errors.accountNumber && touched.accountNumber}
          />

          {errors.accountNumber && touched.accountNumber && (
            <div className="text-red-500">{errors.accountNumber}</div>
          )}
          <div>
            <DropDown
              options={options}
              selected={selectedInput}
              setSelected={setSelectedInput}
              value={value}
              setValue={setValue}
            />
          </div>
          <div className="mt-6">
            <div className="flex items-center justify-end flex-col md:flex-row flex-wrap">
              <div className="w-full">
                <Button
                  className="w-full px-3 py-5 bg-primary text-light hover:opacity-95 transition-all ease-linear duration-500"
                  label="Update"
                  loading={loading}
                  type="submit"
                />
              </div>
              <div className="ml-0 md:ml-2 mt-3 md:mt-0 w-full md:w-64 self-end"></div>
            </div>
          </div>
        </form>
      </Card>
    </section>
  );
};
const NonNigerianBankModal = ({
  setNonNigerianBankModal,
  selectedInput,
  setSelectedInput,
  options,
  loading,
  updateBank,
  accountNumber,
  setAccountNumber,
  accountNo,
  setAccountNo,
  accountName,
  setAccountName,
  value,
  setValue,
}) => {
  const { handleChange, handleSubmit, errors, values, touched, setFieldValue } =
    useFormik({
      initialValues: { accountNumber: "", accountName: "" },
      validationSchema: Yup.object({
        accountNumber: Yup.string().required("Account number is required"),
        accountName: Yup.string().required("Account Name is required"),
      }),
      onSubmit: (values) => {
        setAccountNo(values.accountNumber.replace(/[^a-zA-Z0-9 ]/g, ""));
        setAccountName(values.accountName);
      },
    });

  return (
    <section className="h-full w-screen z-50 bg-black flex items-center justify-center fixed top-0 left-0 bg-opacity-40">
      <Card className="w-96">
        <div className="flex items-center justify-between">
          <div></div>
          <div>
            <button onClick={() => setNonNigerianBankModal(false)}>
              <Image src={deleteIcon} alt="Stakecut | Affiliate Marketplace" />
            </button>
          </div>
        </div>
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            handleSubmit();
            updateBank();
          }}
        >
          <div className="mb-7 mt-10">
            <h2 className="text-md font-medium">Mobile Money</h2>
          </div>
          <div>
            <Input
              placeholder="Enter Account Number"
              onChange={(e) => {
                setFieldValue(
                  "accountNumber",
                  e.target.value.replace(/[^a-zA-Z0-9 ]/g, "")
                );
                setAccountNo(e.target.value.replace(/[^a-zA-Z0-9 ]/g, ""));
              }}
              type="text"
              name="accountNumber"
              value={values.accountNumber}
              error={errors.accountNumber && touched.accountNumber}
            />

            {errors.accountNumber && touched.accountNumber && (
              <div className="text-red-500">{errors.accountNumber}</div>
            )}
          </div>
          <div>
            <Input
              placeholder="Enter Account Name"
              onChange={(e) => {
                setFieldValue("accountName", e.target.value);
                setAccountName(e.target.value);
              }}
              type="text"
              name="accountName"
              value={values.accountName}
              error={errors.accountName && touched.accountName}
            />

            {errors.accountName && touched.accountName && (
              <div className="text-red-500">{errors.accountName}</div>
            )}
          </div>

          <div>
            <DropDown
              options={options}
              selected={selectedInput}
              setSelected={setSelectedInput}
              value={value}
              setValue={setValue}
            />
          </div>
          <div className="mt-6">
            <div className="flex items-center justify-end flex-col md:flex-row flex-wrap">
              <div className="w-full">
                <Button
                  className="w-full px-3 py-5 bg-primary text-light hover:opacity-95 transition-all ease-linear duration-500"
                  label="Update"
                  loading={loading}
                  type="submit"
                  disabled={errors.accountName && errors.accountNumber}
                />
              </div>
              <div className="ml-0 md:ml-2 mt-3 md:mt-0 w-full md:w-64 self-end"></div>
            </div>
          </div>
        </form>
      </Card>
    </section>
  );
};

const CountryModal = ({
  setSelectCountryModal,
  selectedInput,
  setSelectedInput,
  options,
  loading,
  updateProfile,
  setValue,
  value,
}) => {
  const handleCountryChange = (event) => {
    const countryCode = event.target.value;
    const country = countriesData.find(
      (country) => country.name.common === countryCode
    );
    setSelectedInput(countryCode); // Update selected country code
    setSelectedCountry(country); // Update selected country object
  };

  const [selectedCountry, setSelectedCountry] = useState(null);

  return (
    <div className="">
      <div className="">
        <button className="relative w-full">
          <select
            onChange={handleCountryChange}
            className="text-[10px] lg:text-[13px] border-[1px] out leading-[14px] font-[500] text-[500] rounded-xl text-[#205363] outline-[1px] outline-[#fff] border-[#205363] py-5 appearance-none bg-transparent outline-none  w-[100%] "
            value={selectedInput}
          >
            <option value="">country</option>
            {countriesData.map((country) => (
              <option
                key={country.cca3}
                value={country.name.common}
                style={{ backgroundImage: `url(${country.flags.svg})` }}
              >
                {country.name.common}
              </option>
            ))}
          </select>
          {selectedCountry && (
            <div className="absolute inset-y-0  right-0 flex items-center px-2 pointer-events-none">
              <img
                src={selectedCountry.flags.svg}
                alt={`Flag of ${selectedCountry.name.common}`}
                className="w-12 h-auto "
              />
            </div>
          )}
        </button>
      </div>

    </div>
  );
};



const createAxiosInstance = () => {
  const authToken = cookies.get("authToken");
  const BASE_URL = process.env.NEXT_PUBLIC_API_URL || "https://xxx.stakecut.com/api/";

  const axiosInstance = axios.create({
    baseURL: BASE_URL,
    timeout: 60000,
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${authToken}`,
    },
  });

  createAuthRefreshInterceptor(axiosInstance, async (failedRequest) => {
    try {
      const response = await axiosInstance.get("/api/refreshToken");
      const { accessToken } = response.data;

      // Update tokens
      cookies.set("authToken", accessToken, { path: "/", secure: true, sameSite: "strict" });
      const bearer = `Bearer ${accessToken}`;
      axiosInstance.defaults.headers.authorization = bearer;

      const responseCookie = setCookie.parse(response.headers["set-cookie"])[0];
      axiosInstance.defaults.headers.cookie = cookie.serialize(
        responseCookie.name,
        responseCookie.value
      );
      failedRequest.response.config.headers.authorization = bearer;

      return Promise.resolve();
    } catch (error) {
      console.error("Error refreshing token:", error);
      toast.error("Session expired. Please log in again.");
      // Redirect to login page
      window.location.href = "/auth/sign-in";
      return Promise.reject(error);
    }
  });

  return axiosInstance;
};

const CountryModalBank = ({
  setSelectCountryModal,
  selectedInput,
  setSelectedInput,
  options,
  loading,
  setValue,
  value,
  setPaymentOptions,
  setBanks,
  setMemoOptions,
}) => {
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dropdownRef = useRef(null);

  const axiosInstance = createAxiosInstance();

  const calculateDropdownPosition = () => {
    if (dropdownRef.current) {
      const buttonRect = dropdownRef.current.getBoundingClientRect();
      return {
        top: buttonRect.bottom + window.scrollY + 10,
        left: buttonRect.left + window.scrollX,
      };
    }
    return {};
  };

  const dropdownPosition = calculateDropdownPosition();

  const fetchPaymentInformation = async (countryCode) => {
    try {
      const response = await axiosInstance.get(`/profile/payment-options/${countryCode}`);
      return response.data.data.paymentOptions || [];
    } catch (error) {
      console.error("Error fetching payment options:", error);
      toast.error("Failed to fetch payment options. Please try again.");
      return [];
    }
  };

  // const fetchBanksByCountry = async (countryCode) => {
  //   try {
  //     const response = await axiosInstance.get(`/profile/banks/${countryCode}`);
  //     return response.data.data || [];
  //   } catch (error) {
  //     console.error("Error fetching banks:", error);
  //     toast.error("Failed to fetch banks. Please try again.");
  //     return [];
  //   }
  // };

  // const fetchMemoByCountry = async (countryCode) => {
  //   try {
  //     const response = await axiosInstance.get(`/profile/momo-pay-options/${countryCode}`);
  //     return response.data.data.data.options || [];
  //   } catch (error) {
  //     console.error("Error fetching memo options:", error);
  //     toast.error("Failed to fetch mobile money options. Please try again.");
  //     return [];
  //   }
  // };
  
const fetchBanksByCountry = async (countryCode) => {
  try {
    const response = await axiosInstance.get(`/profile/banks/${countryCode}`);
    return response?.data?.data || [];
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message;

    const knownErrors = [
      "An Error Occurred: HTTPError: Response code 404 (Not Found)",
    ];

    console.error("Error fetching banks:", errorMessage);

    if (!knownErrors.includes(errorMessage)) {
      toast.error("Failed to fetch banks. Please try again.");
    }

    return [];
  }
};
const fetchMemoByCountry = async (countryCode) => {
  try {
    const response = await axiosInstance.get(`/profile/momo-pay-options/${countryCode}`);
    return response?.data?.data?.data?.options || [];
  } catch (error) {
    const status = error?.response?.status;
    const errorMessage = error?.response?.data?.message || error?.message;

    const knownErrors = [
      "No memo pay options found for country and payment option: momo",
      "An Error Occurred: HTTPError: Response code 404 (Not Found)",
    ];

    console.error("Error fetching memo options:", errorMessage);

    // Suppress toast for known errors or if status is 400
    if (!knownErrors.includes(errorMessage) && status !== 400) {
      toast.error("Failed to fetch mobile money options. Please try again.");
    }

    return [];
  }
};


  // Debounce the handleCountryChange to prevent multiple simultaneous API calls
  const debouncedHandleCountryChange = useCallback(
    debounce(async (countryCode) => {
      const country = countriesData.find(
        (country) => country.name.common === countryCode
      );
      setSelectedInput(countryCode);
      setSelectedCountry(country);
      setIsDropdownOpen(false);
      setIsLoading(true);

      try {
        // Fetch payment options
        const paymentOptions = await fetchPaymentInformation(countryCode);
        setPaymentOptions(paymentOptions);

        // Fetch banks
        const banks = await fetchBanksByCountry(country.cca2);
        setBanks(banks);

        // Fetch memo options
        const memoOptions = await fetchMemoByCountry(country.cca2);
        setMemoOptions(memoOptions);
      } catch (error) {
        console.error("Error in handleCountryChange:", error);
      } finally {
        setIsLoading(false);
      }
    }, 500), // 500ms debounce delay
    [setSelectedInput, setSelectedCountry, setIsDropdownOpen, setPaymentOptions, setBanks, setMemoOptions]
  );

  const handleCountryChange = (countryCode) => {
    debouncedHandleCountryChange(countryCode);
  };

  const handleSearchChange = (e) => {
    setSearchInput(e.target.value);
  };

  const filteredCountries = countriesData.filter((country) =>
    country.name.common.toLowerCase().includes(searchInput.toLowerCase())
  );
  const sortedCountries = filteredCountries.sort((a, b) =>
    a.name.common.localeCompare(b.name.common, "en", { sensitivity: "base" })
  );

  return (
    <div className="top-[13%] lg:top-[18%] lg:right-[2.5%] md:right-[2.3%] right-[4%] lg:w-[180px] w-[120px] absolute">
      <button
        className="w-full"
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        ref={dropdownRef}
      >
        <div className="text-[10px] lg:text-[13px] lg:px-4 px-[4px] h-[49px] border-[1px] leading-[14px] font-[500] rounded-xl text-[#282828] focus:outline-none border-[#205363] w-full flex items-center justify-between">
          {selectedCountry ? selectedCountry.name.common : "Select country"}
          {selectedCountry && (
            <img
              src={selectedCountry.flags.svg}
              alt={`Flag of ${selectedCountry.name.common}`}
              className="w-[40px] rounded-[6px]"
            />
          )}
        </div>
      </button>
      {isDropdownOpen && (
        <div className="bg-white border border-[#205363] rounded-tl-xl rounded-br-xl shadow-xl w-full mt-2 z-10">
          <input
            type="text"
            className="w-full p-2 text-[10px] lg:text-[10px] border-white border-b-2 focus:outline-none"
            placeholder="Search country name"
            value={searchInput}
            onChange={handleSearchChange}
          />
          <div className="max-h-60 border-t-[1px] overflow-y-auto">
            {sortedCountries.map((country) => (
              <div
                key={country.cca3}
                className="p-2 cursor-pointer hover:bg-gray-200"
                onClick={() => handleCountryChange(country.name.common)}
              >
                {country.name.common}
              </div>
            ))}
          </div>
        </div>
      )}
      {isLoading && (
        <div className="mt-2 text-sm text-gray-500">Loading...</div>
      )}
    </div>
  );
};

export default CountryModalBank;
const BankBranchModal = ({
  isOpen,
  banks,
  accountNumber,
  setBankName,
  setAccountNo,
  setAccountName,
  branchName,
  setBranchName,
  closeModal,
  updateBank,
}) => {
  const [selectedBank, setSelectedBank] = useState("");
  const [accountNo, setAccountNumber] = useState(accountNumber || "");
  const [accountName, setAccountNameLocal] = useState("");
  const [branch, setBranch] = useState(branchName || "");

  const handleUpdate = () => {
    setBankName(selectedBank);
    setAccountNo(accountNo);
    setAccountName(accountName);
    setBranchName(branch);
    updateBank();
  };

  return (
    <Modal open={isOpen} onClose={closeModal}>
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
          <h2 className="text-xl font-bold mb-4">Add Bank Account (Ghana)</h2>
          <div className="mb-4">
            <label
              htmlFor="bank"
              className="block text-sm font-medium text-gray-700"
            >
              Bank Name
            </label>
            <select
              id="bank"
              name="bank"
              className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
              value={selectedBank}
              onChange={(e) => setSelectedBank(e.target.value)}
            >
              <option value="">Select Bank</option>
              {banks.map((bank) => (
                <option key={bank.value} value={bank.value}>
                  {bank.label}
                </option>
              ))}
            </select>
          </div>
          <EditInput
            label="Account Number"
            type="text"
            value={accountNo}
            placeholder="Enter Account Number"
            onChange={(e) => setAccountNumber(e.target.value)}
          />
          <EditInput
            label="Account Name"
            type="text"
            value={accountName}
            placeholder="Enter Account Name"
            onChange={(e) => setAccountNameLocal(e.target.value)}
          />
          <EditInput
            label="Branch Name"
            type="text"
            value={branch}
            placeholder="Enter Branch Name"
            onChange={(e) => setBranch(e.target.value)}
          />
          <div className="mt-4 flex justify-end space-x-2">
            <Button variant="secondary" onClick={closeModal}>
              Cancel
            </Button>
            <Button onClick={handleUpdate}>Save</Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export {
  AddBankModal,
  CountryModal,
  NonNigerianBankModal,
  BankBranchModal,
  CountryModalBank,
};
